import taustPilt from './taust.jpg'
import { useState, useEffect, useCallback } from 'react'
import { supabase } from './supabaseClient'
import './App.css'

const TOETAJAD = ['Strongway', 'Freeway', 'DPD', 'HJH', 'Muu / Lisainimene']
const DIET_OPTIONS = [
  { id: 'Hommikusook',  label: '🥛 Hommikusöök' },
  ]

const AJAKAVA = [
  { aeg: '14:00–14:30', tegevus: 'Kogunemine',          ikoon: '🚗' },
  { aeg: '14:30–17:00', tegevus: 'Tegevused ja mängud',   ikoon: '🎤' },
  { aeg: '17:00–18:00', tegevus: 'Õhtusöök',                     ikoon: '🍽️' },
  { aeg: '18:00–19:00', tegevus: 'Tegevused ja mängud',                      ikoon: '🏟️' },
  { aeg: '19:00–02:00', tegevus: 'Vaba aeg',                  ikoon: '🎧' },
  { aeg: '09:00–11:00', tegevus: 'Hommikusöök',                  ikoon: '☀️' },
]

const EMPTY_FORM = {
  nimi: '', ettevote: '', email: '', telefon: '',
  majutus: 'jah', toitumine: [], muud: '',
  kaaslanega: false, kaaslane_nimi: '', kaaslane_email: '', kaaslane_telefon: '',
}
const AVATAR_COLORS = ['#2d5a3d','#1a3320','#5a8a6a','#8a5a2d','#5a3a8a','#2d5a8a']
const avatarColor = (name) => AVATAR_COLORS[name.charCodeAt(0) % AVATAR_COLORS.length]

// ══════════════════════════════════════════════════════════════
// ADMIN PANEEL
// ══════════════════════════════════════════════════════════════
function AdminPanel({ onBack, data: initialData}) {
  const [participants, setParticipants] = useState([])
  const [loading, setLoading]           = useState(true)
  const [search, setSearch]             = useState('')
  const [filter, setFilter]             = useState('all') // all | paid | unpaid
  const [updating, setUpdating]         = useState(null)
  const [sortCol, setSortCol]           = useState('created_at')
  const [sortDir, setSortDir]           = useState('asc')

  const load = useCallback(async () => {
    const { data } = await supabase
      .from('registrations')
      .select('*')
      .order('created_at', { ascending: true })
    setParticipants(data || [])
    setLoading(false)
  }, [])

  useEffect(() => {
    load()
    const ch = supabase.channel('admin-changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'registrations' }, load)
      .subscribe()
    return () => supabase.removeChannel(ch)
  }, [load])

  const togglePayment = async (p) => {
    setUpdating(p.id)
    const next = p.payment_status === 'unpaid' ? 'paid'
      : p.payment_status === 'paid' ? 'free'
      : 'unpaid'
    const { error } = await supabase.from('registrations').update({ payment_status: next }).eq('id', p.id)
    if (error) { alert('Viga: ' + error.message); setUpdating(null); return }
    setParticipants(prev => prev.map(x => x.id === p.id ? { ...x, payment_status: next } : x))
    setUpdating(null)
  }

  const exportCSV = () => {
    const header = ['#','Nimi','Ettevõte','Email','Telefon','Majutus','Kaaslane','Kaaslase nimi','Toitumine','Märkused','Makse','Registreeritud']
    const rows = filtered.map((p, i) => [
      i + 1, p.nimi, p.ettevote, p.email || '—', p.telefon || '—',
      p.majutus === 'jah' ? 'Jah' : 'Ei',
      p.kaaslanega ? 'Jah' : 'Ei',
      p.kaaslane_nimi || '—',
      Array.isArray(p.toitumine) ? p.toitumine.join('; ') : '—',
      p.muud || '—',
      p.payment_status === 'paid' ? 'Makstud' : 'Tasumata',
      new Date(p.created_at).toLocaleString('et-EE'),
    ])
    const csv = [header, ...rows].map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob)
    a.download = 'osalejad_2026.csv'; a.click()
  }

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(col); setSortDir('asc') }
  }

  const filtered = participants
    .filter(p => {
      const q = search.toLowerCase()
      const matchSearch = !q || p.nimi?.toLowerCase().includes(q) || p.ettevote?.toLowerCase().includes(q) || p.email?.toLowerCase().includes(q)
      const matchFilter = filter === 'all' || p.payment_status === filter
      return matchSearch && matchFilter
    })
    .sort((a, b) => {
      let va = a[sortCol] ?? ''; let vb = b[sortCol] ?? ''
      if (sortDir === 'desc') [va, vb] = [vb, va]
      return String(va).localeCompare(String(vb))
    })

  const totalAmt   = participants.filter(p => p.payment_status !== 'free').reduce((s, p) => s + (p.kaaslanega ? 50 : 25), 0)
  const paidAmt    = participants.filter(p => p.payment_status === 'paid').reduce((s, p) => s + (p.kaaslanega ? 50 : 25), 0)
  const paidCount  = participants.filter(p => p.payment_status === 'paid').length
  const unpaidCnt  = participants.filter(p => p.payment_status === 'unpaid').length
  const unpaidCount = unpaidCnt
  const unpaidAmt  = participants.filter(p => p.payment_status === 'unpaid').reduce((s, p) => s + (p.kaaslanega ? 50 : 25), 0)
  const deadline = (createdAt) => {
    const d = new Date(createdAt); d.setDate(d.getDate() + 3)
    const now = new Date()
    const diff = Math.ceil((d - now) / 86400000)
    return { str: d.toLocaleDateString('et-EE'), overdue: diff < 0, today: diff === 0, diff }
  }

  const SortIcon = ({ col }) => sortCol !== col ? <span style={{opacity:.3}}>↕</span>
    : sortDir === 'asc' ? <span>↑</span> : <span>↓</span>

  return (
    <div className="admin-page">
      {/* ── ADMIN HEADER ── */}
      <div className="admin-topbar">
        <div className="admin-topbar-left">
          <button className="admin-back-btn" onClick={onBack}>← Tagasi</button>
          <div>
            <h1 className="admin-title">⚙️ Admin paneel</h1>
            <p className="admin-subtitle">KSP 2026 — Maksete haldus</p>
          </div>
        </div>
        <button className="admin-export-top" onClick={exportCSV}>⬇️ Ekspordi CSV</button>
      </div>

      <div className="admin-content">
        {/* ── STATISTIKA KAARDID ── */}
        <div className="admin-stats-grid">
          <div className="astat-card astat-total">
            <div className="astat-val">{participants.reduce((s, p) => s + (p.kaaslanega ? 2 : 1), 0)}</div>
            <div className="astat-lbl">Osalejat</div>
            <div className="astat-sub">{participants.length} registreeringut</div>
          </div>
          <div className="astat-card astat-paid">
            <div className="astat-val">{paidCount}</div>
            <div className="astat-lbl">✅ Makstud</div>
            <div className="astat-sub">{paidAmt} €</div>
          </div>
          <div className="astat-card astat-free">
            <div className="astat-val">{participants.filter(p => p.payment_status === 'free').length}</div>
            <div className="astat-lbl">🎟️ Tasuta</div>
          </div>
          <div className="astat-card astat-unpaid">
            <div className="astat-val">{unpaidCnt}</div>
            <div className="astat-lbl">⏳ Tasumata</div>
            <div className="astat-sub">{unpaidAmt} €</div>
          </div>
          <div className="astat-card astat-total">
            <div className="astat-val">{totalAmt} €</div>
            <div className="astat-lbl">Oodatav kogutulu</div>
            <div className="astat-sub">{paidAmt} € laekunud</div>
          </div>
        </div>
       
        {/* ── FILTRID JA OTSING ── */}
        <div className="admin-toolbar">
          <input
            className="admin-search"
            placeholder="🔍  Otsi nime, ettevõtte või e-posti järgi..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <div className="admin-filters">
            {[['all','Kõik'],['unpaid','Tasumata'],['paid','Makstud']].map(([v, l]) => (
              <button key={v} className={`filter-btn ${filter === v ? 'active' : ''}`}
                onClick={() => setFilter(v)}>{l}</button>
            ))}
          </div>
        </div>

        {/* ── TABEL ── */}
        {loading ? (
          <div className="admin-loading">⏳ Laadimine...</div>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th onClick={() => handleSort('nimi')} className="sortable">Nimi <SortIcon col="nimi"/></th>
                  <th onClick={() => handleSort('ettevote')} className="sortable">Ettevõte <SortIcon col="ettevote"/></th>
                  <th>Kontakt</th>
                  <th>Info</th>
                  <th onClick={() => handleSort('created_at')} className="sortable">Tähtaeg <SortIcon col="created_at"/></th>
                  <th>Summa</th>
                  <th onClick={() => handleSort('payment_status')} className="sortable">Makse <SortIcon col="payment_status"/></th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={8} style={{textAlign:'center',padding:'32px',color:'#888'}}>Tulemused puuduvad</td></tr>
                ) : filtered.map((p, i) => {
                  const dl = deadline(p.created_at)
                  const isPaid = p.payment_status === 'paid'
                  return (
                    <tr key={p.id} className={isPaid ? 'row-paid' : dl.overdue ? 'row-overdue' : ''}>
                      <td className="td-num">{i + 1}</td>
                      <td>
                        <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                          <div className="mini-avatar" style={{background: avatarColor(p.nimi)}}>
                            {p.nimi.charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <div className="td-name">{p.nimi}</div>
                            {p.kaaslanega && <div className="td-sub">+1 {p.kaaslane_nimi}</div>}
                          </div>
                        </div>
                      </td>
                      <td><span className="company-badge">{p.ettevote}</span></td>
                      <td>
                        <div className="td-sub">{p.email || '—'}</div>
                        <div className="td-sub">{p.telefon || '—'}</div>
                      </td>
                      <td>
                        {p.majutus === 'jah' && <span className="info-chip">🏠 Majutus</span>}
                        {p.toitumine?.length > 0 && <span className="info-chip">🥗 Dieet</span>}
                      </td>
                      <td>
                        <div className={`deadline-badge ${dl.overdue ? 'overdue' : dl.today ? 'today' : ''}`}>
                          {dl.str}
                          {dl.overdue && <div style={{fontSize:'10px'}}>Tähtaeg möödas!</div>}
                          {dl.today && <div style={{fontSize:'10px'}}>Täna!</div>}
                        </div>
                      </td>
                      <td className="td-amt">{p.payment_status === 'free' ? '—' : p.kaaslanega ? '50 €' : '25 €'}</td>
                      <td>
                        <button
                          className={`pay-toggle ${p.payment_status === 'paid' ? 'is-paid' : p.payment_status === 'free' ? 'is-free' : 'is-unpaid'}`}
                          onClick={() => togglePayment(p)}
                          disabled={updating === p.id}
                        >
                          {updating === p.id ? '...' : p.payment_status === 'paid' ? '✅ Makstud' : p.payment_status === 'free' ? '🎟️ Tasuta' : '⏳ Tasumata'}
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Ettevõtete kokkuvõte */}
        <div className="company-summary">
          <h3 className="cs-title">Ettevõtete kokkuvõte</h3>
          <div className="cs-grid">
            {TOETAJAD.map(t => {
              const all   = participants.filter(p => p.ettevote === t)
              const paid  = all.filter(p => p.payment_status === 'paid')
              const pct   = all.length ? Math.round(paid.length / all.length * 100) : 0
              return all.length > 0 ? (
                <div className="cs-card" key={t}>
                  <div className="cs-name">{t}</div>
                  <div className="cs-count">{all.length} osalejat</div>
                  <div className="cs-bar-bg">
                    <div className="cs-bar-fg" style={{width: `${pct}%`}} />
                  </div>
                  <div className="cs-pct">{paid.length}/{all.length} makstud</div>
                </div>
              ) : null
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// PEAMINE APP
// ══════════════════════════════════════════════════════════════
export default function App() {
  const [page, setPage]                 = useState('home') // home | admin
  const [adminPin, setAdminPin]         = useState('')
  const [adminUnlocked, setAdminUnlocked] = useState(false)
  const [pinError, setPinError]         = useState(false)
  const [showPinModal, setShowPinModal] = useState(false)
  const [adminData, setAdminData]       = useState([])

  const [view, setView]                 = useState('form')
  const [form, setForm]                 = useState(EMPTY_FORM)
  const [errors, setErrors]             = useState({})
  const [submitting, setSubmitting]     = useState(false)
  const [participants, setParticipants] = useState([])
  const [loading, setLoading]           = useState(true)
  const [fetchError, setFetchError]     = useState(null)

 const totalParticipants = participants.reduce(
  (sum, p) => sum + 1 + (p.kaaslanega ? 1 : 0),
  0
)

  const loadParticipants = useCallback(async () => {
    const { data, error } = await supabase
      .from('public_registrations')
      .select('nimi,created_at,kaaslanega')
      .order('created_at', { ascending: true })
    if (error) setFetchError('Osalejate laadimine ebaõnnestus.')
    else       { setParticipants(data || []); setFetchError(null) }
    setLoading(false)
  }, [])

  useEffect(() => {
    loadParticipants()
    const ch = supabase.channel('reg-changes')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'registrations' },
        payload => loadParticipants())
      .subscribe()
    return () => supabase.removeChannel(ch)
  }, [loadParticipants])

  const validate = () => {
    const e = {}
    if (!form.nimi.trim())  e.nimi = 'Nimi on kohustuslik'
    if (!form.ettevote)     e.ettevote = 'Vali ettevõte'
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Vigane e-posti aadress'
    if (form.kaaslanega && !form.kaaslane_nimi.trim()) e.kaaslane_nimi = 'Kaaslase nimi on kohustuslik'
    return e
  }

  const handleSubmit = async () => {
    const e = validate()
    if (Object.keys(e).length) { setErrors(e); return }
    setSubmitting(true)
    const { error } = await supabase.from('registrations').insert([{
      nimi: form.nimi.trim(), ettevote: form.ettevote,
      email: form.email.trim() || null, telefon: form.telefon.trim() || null,
      majutus: form.majutus, toitumine: form.toitumine.length ? form.toitumine : null,
      muud: form.muud.trim() || null, kaaslanega: form.kaaslanega,
      kaaslane_nimi:    form.kaaslanega ? form.kaaslane_nimi.trim() : null,
      kaaslane_email:   form.kaaslanega ? form.kaaslane_email.trim() || null : null,
      kaaslane_telefon: form.kaaslanega ? form.kaaslane_telefon.trim() || null : null,
    }])
    if (error) alert('Viga salvestamisel: ' + error.message)
    else       setView('success')
    setSubmitting(false)
  }

  const resetForm = () => { setForm(EMPTY_FORM); setErrors({}); setView('form') }
  const toggleDiet = (id) => setForm(f => ({
    ...f, toitumine: f.toitumine.includes(id)
      ? f.toitumine.filter(x => x !== id) : [...f.toitumine, id]
  }))

 const handleAdminLogin = async () => {
  try {
    setPinError(false)

    const res = await fetch(
       "https://yzviolggjwcceldgquox.supabase.co/functions/v1/verify-admin",
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "apikey": import.meta.env.VITE_SUPABASE_ANON_KEY,
      "Authorization": `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify({ pin: adminPin })
      }
    )

    if (!res.ok) {
      throw new Error("Unauthorized")
    }

    const data = await res.json()

    setAdminData(data)
    setAdminUnlocked(true)
    setShowPinModal(false)
    setAdminPin("")

  } catch (err) {
    setPinError(true)
  }
}

  const paymentDeadline = () => {
    const d = new Date(); d.setDate(d.getDate() + 3)
    return d.toLocaleDateString('et-EE', { day:'2-digit', month:'2-digit', year:'numeric' })
  }

  // ── Admin leht ──────────────────────────────────────────────
  if (page === 'admin' && adminUnlocked) {
    return <AdminPanel data={adminData} onBack={() => setPage('home')} />
  }

  // ── PIN modal ───────────────────────────────────────────────
  const PinModal = () => (
    <div className="pin-modal-overlay" onClick={() => setShowPinModal(false)}>
      <div className="pin-modal" onClick={e => e.stopPropagation()}>
        <div className="pin-modal-title">🔐 Admin sisselogimine</div>
        <input className="pin-modal-input" type="password" placeholder="Sisesta PIN"
          value={adminPin} onChange={e => setAdminPin(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleAdminLogin()}
          autoFocus />
        {pinError && <div className="error-msg" style={{textAlign:'center'}}>Vale PIN</div>}
        <button className="pin-modal-btn" onClick={handleAdminLogin} disabled={!adminPin}>Sisene →</button>
      </div>
    </div>
  )

    return (
    <div className="app">
        {showPinModal && <PinModal />}
      <header className="header" style={{backgroundImage: `url(${taustPilt})`}}>
        <div className="header-bg" />
        <div className="header-trees" />
        <div className="header-inner">
          <div className="header-left">
            <div className="event-badge">🌲 Suvepäevad 2026</div>
            <h1>Tule<br /><em>suvepäevadele</em> 15. AUGUST 2026</h1>
            <p className="header-subtitle"> Ära maga maha aasta parimat pidu!</p>
            <div className="header-stats">
              <div className="stat-chip"><strong>{loading ? '...' : participants.length}</strong>registreeritut</div>
              <div className="stat-chip">🕑 15. august</div>
              <a href="https://maps.app.goo.gl/aVrciWNGHyeLAEBs9" target="_blank" rel="noopener noreferrer" className="stat-chip stat-chip-link">📍 Ankküla</a>
              <div className="stat-chip"> 25€ </div>
            </div>
            <div className="header-links">
              <a href="https://photos.app.goo.gl/sQ5wseX9Sf5V9Snn9" target="_blank" rel="noopener noreferrer" className="header-link-btn">
                📸 2024 suvepäeva pildid
              </a>
              <a href="https://drive.google.com/drive/folders/1VYrk5FamOmqRGvDhXsVBvT-YVt8b4HER?usp=drive_link" target="_blank" rel="noopener noreferrer" className="header-link-btn">
                📸 2025 suvepäeva pildid
              </a>
            </div>
          </div>
          {!loading && participants.length > 0 && (
            <div className="counter-badge">
              🎉 {totalParticipants} {totalParticipants === 1 ? 'osaleja' : 'osalejat koos kaaslasega'} registreerunud!
            </div>
            )}
            <button className="admin-header-btn"
              onClick={() => adminUnlocked ? setPage('admin') : setShowPinModal(true)}>
              ⚙️ Admin
            </button>
          </div>
        </header>

      <div className="main">
        <div>
          <div className="card">
            <div className="card-header">
              <div className="card-icon">📋</div>
              <h2 className="card-title">Registreeri</h2>
            </div>
            <div className="card-body">

              {view === 'success' ? (
                <div className="success-card">
                  <div className="success-icon">✓</div>
                  <div className="success-title">Oled registreeritud!</div>
                  <p className="success-sub">Registreerimine õnnestus. Koha kinnitamiseks tee palun makse 3 päeva jooksul.</p>

                  <div className="payment-box">
                    <div className="payment-title">💳 Makse juhised</div>

                    <div className="payment-row">
                      <span className="payment-label">Saaja</span>
                      <span className="payment-value">Martin Olesk</span>
                    </div>
                    <div className="payment-row">
                      <span className="payment-label">IBAN</span>
                      {/* ⚠️ ASENDA OMA TEGELIKU IBAN-IGA */}
                      <span className="payment-value iban">EE23 2200 2210 6337 7012</span>
                    </div>
                    <div className="payment-row">
                      <span className="payment-label">Summa</span>
                      <span className="payment-value highlight">
                        {form.kaaslanega ? '50,00 €  (2 × 25 €)' : '25,00 €'}
                      </span>
                    </div>
                    {form.kaaslanega && (
                      <div className="payment-row">
                        <span className="payment-label">Osalejad</span>
                        <span className="payment-value">{form.nimi} + {form.kaaslane_nimi}</span>
                      </div>
                    )}
                    <div className="payment-row">
                      <span className="payment-label">Selgitus</span>
                      <span className="payment-value highlight">{form.nimi} KSP2026</span>
                    </div>
                    <div className="payment-row">
                      <span className="payment-label">Tähtaeg</span>
                      <span className="payment-value deadline">{paymentDeadline()}</span>
                    </div>

                    <div className="payment-note">
                      ⚠️ Maksa <strong>3 päeva jooksul</strong> — vastasel juhul tühistatakse koht automaatselt.
                    </div>
                    <div className="payment-refund">
                      💚 <strong>Tagastuspoliitika:</strong> Tühistamisel <strong>14 või rohkem päeva</strong> enne üritust tagastatakse makse täies ulatuses. Hilisemal tühistamisel makse ei tagastata.
                    </div>
                    <div className="payment-cash">
                      <div className="payment-cash-title">💵 Sularahas maksmine</div>
                      <p>Kui pangaülekanne ei sobi, on võimalik maksta sularahas. Palun maksa osalustasu Mariliis Nõmmele:</p>
                      {/* ⚠️ ASENDA OMA TEGELIKU E-POSTIGA */}
                      <a href="mailto:mariliis@freeway.ee" className="payment-cash-email">mariliis@freeway.ee</a>
                      <p style={{marginTop: '6px', fontSize: '12px', color: 'var(--text-soft)'}}>
                        ⚠️ Sularahamakse palun teha täpses summas.
                      </p>
                    </div>
                  </div>

                  <button className="back-btn" onClick={resetForm} style={{marginTop: '16px'}}>
                    Registreeri veel keegi
                  </button>
                </div>
              ) : (
                <div className={`form ${submitting ? 'loading' : ''}`}>
                  <div className="field-row">
                    <div className="field">
                      <label>Nimi <span className="req">*</span></label>
                      <input placeholder="Eesnimi Perenimi" value={form.nimi}
                        onChange={e => { setForm(f=>({...f,nimi:e.target.value})); setErrors(er=>({...er,nimi:''})) }}/>
                      {errors.nimi && <span className="error-msg">{errors.nimi}</span>}
                    </div>
                    <div className="field">
                      <label>Ettevõte <span className="req">*</span></label>
                      <select value={form.ettevote}
                        onChange={e => { setForm(f=>({...f,ettevote:e.target.value})); setErrors(er=>({...er,ettevote:''})) }}>
                        <option value="">Vali...</option>
                        {TOETAJAD.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                      {errors.ettevote && <span className="error-msg">{errors.ettevote}</span>}
                    </div>
                  </div>
                  <div className="field-row">
                    <div className="field">
                      <label>E-post</label>
                      <input type="email" placeholder="nimi@email.ee" value={form.email}
                        onChange={e => { setForm(f=>({...f,email:e.target.value})); setErrors(er=>({...er,email:''})) }}/>
                      {errors.email && <span className="error-msg">{errors.email}</span>}
                    </div>
                    <div className="field">
                      <label>Telefon</label>
                      <input placeholder="+372 ..." value={form.telefon}
                        onChange={e => setForm(f=>({...f,telefon:e.target.value}))}/>
                    </div>
                  </div>
                  <div className="divider" />

                  <div className="field">
                    <label>Majutus</label>
                    <div className="radio-group">
                      {[{v:'jah',l:'✅ Jah, vajan majutust'},{v:'ei',l:'🚗 Ei vaja majutust'}].map(o => (
                        <label key={o.v} className={`radio-pill ${form.majutus === o.v ? 'active' : ''}`}>
                          <input type="radio" value={o.v} checked={form.majutus === o.v} onChange={() => setForm(f => ({...f, majutus: o.v}))} />
                          {o.l}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="field">
                    <label>Märgi linnukesega, kui soovid pühapäeval hommikusööki</label>
                    <div className="checkbox-group">
                      {DIET_OPTIONS.map(o => (
                        <label key={o.id} className={`checkbox-item ${form.toitumine.includes(o.id) ? 'active' : ''}`}>
                          <input type="checkbox" checked={form.toitumine.includes(o.id)} onChange={() => toggleDiet(o.id)} />
                          <span className="check-box">{form.toitumine.includes(o.id) ? '✓' : ''}</span>
                          {o.label}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="divider" />

                  <div className="field">
                    <label>Kaaslane</label>
                    <label className={`checkbox-item ${form.kaaslanega ? 'active' : ''}`}>
                      <input type="checkbox" checked={form.kaaslanega}
                        onChange={() => setForm(f => ({...f, kaaslanega: !f.kaaslanega}))} />
                      <span className="check-box">{form.kaaslanega ? '✓' : ''}</span>
                      👫 Toon kaaslase (+1 isik) — tasu <strong style={{marginLeft:'4px'}}>50 € (2 × 25 €)</strong>
                    </label>
                  </div>

                  {form.kaaslanega && (
                    <div className="companion-box">
                      <div className="companion-title">👤 Kaaslase andmed</div>
                      <div className="field">
                        <label>Kaaslase nimi <span className="req">*</span></label>
                        <input placeholder="Eesnimi Perenimi" value={form.kaaslane_nimi}
                          onChange={e => { setForm(f => ({...f, kaaslane_nimi: e.target.value})); setErrors(er => ({...er, kaaslane_nimi: ''})) }} />
                        {errors.kaaslane_nimi && <span className="error-msg">{errors.kaaslane_nimi}</span>}
                      </div>
                      <div className="field-row" style={{marginTop: '12px'}}>
                        <div className="field">
                          <label>Kaaslase e-post</label>
                          <input type="email" placeholder="nimi@email.ee" value={form.kaaslane_email}
                            onChange={e => setForm(f => ({...f, kaaslane_email: e.target.value}))} />
                        </div>
                        <div className="field">
                          <label>Kaaslase telefon</label>
                          <input placeholder="+372 ..." value={form.kaaslane_telefon}
                            onChange={e => setForm(f => ({...f, kaaslane_telefon: e.target.value}))} />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="field">
                    <label>Muud märkused</label>
                    <textarea placeholder="Muid soove või infot korraldajatele..." value={form.muud}
                      onChange={e => setForm(f => ({...f, muud: e.target.value}))} />
                  </div>

                  <button className="submit-btn" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? 'Salvestamine...' : '🌲 Registreeri suvepäevadele'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="sidebar">
          <div className="card">
            <div className="card-header"><div className="card-icon">👥</div><h2 className="card-title">Osalejad</h2></div>
            <div className="card-body">
              {fetchError && <p className="error-msg">{fetchError}</p>}
              {loading ? <div className="empty-state"><div className="empty-icon">⏳</div>Laadimine...</div>
              : participants.length === 0 ? <div className="empty-state"><div className="empty-icon">🌱</div>Ole esimene registreeruja!</div>
              : <div className="participant-list">
                  {participants.map((p, i) => (
                    <div className="participant-item" key={p.id}>
                      <div className="participant-avatar" style={{background:avatarColor(p.nimi)}}>
                        {p.nimi.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div className="participant-name">{p.nimi}{p.kaaslanega?' +1':''}</div>
                        <div className="participant-company">{p.ettevote}</div>
                      </div>
                      <div className="participant-number">#{i+1}</div>
                    </div>
                  ))}
                </div>}
            </div>
          </div>
          <div className="card">
            <div className="card-header"><div className="card-icon">🕐</div><h2 className="card-title">Ajakava</h2></div>
            <div className="card-body">
              {AJAKAVA.map((item,i) => (
                <div className="schedule-item" key={i}>
                  <div className="schedule-icon">{item.ikoon}</div>
                  <div><div className="schedule-time">{item.aeg}</div><div className="schedule-name">{item.tegevus}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    
  )

}
